import bus from '@/utils/bus';
import pageShare from '@/utils/page-share';

const shareMixin = {
  methods: {
    listenChangePageShareEvent() {
      bus.$on('changePageShareInfo', () => {
        const path = window.location.href;
        const item = pageShare.get(path);
        if (item) {
          this.$wechat.changeShareParams(item.share);
        }
      });
    },
  },
  created() {
    this.listenChangePageShareEvent();
  },
  beforeRouteUpdate(to, from, next) {
    this.listenChangePageShareEvent();
    next();
  },
  beforeDestroy() {
    const path = window.location.href;
    pageShare.remove(path);
  },
};

export default shareMixin;
